import React from 'react';
interface FlavorProfileProps {
  profile: {
    acidity: number;
    sweetness: number;
    bitterness: number;
    body: number;
    complexity: number;
  };
  setProfile: React.Dispatch<React.SetStateAction<{
    acidity: number;
    sweetness: number;
    bitterness: number;
    body: number;
    complexity: number;
  }>>;
  readOnly?: boolean;
}
export const FlavorProfile: React.FC<FlavorProfileProps> = ({
  profile,
  setProfile,
  readOnly = false
}) => {
  const handleChange = (attribute: string, value: number) => {
    if (readOnly) return;
    setProfile(prev => ({
      ...prev,
      [attribute]: value
    }));
  };
  const attributes = [{
    name: 'acidity',
    label: 'Acidez'
  }, {
    name: 'sweetness',
    label: 'Dulzura'
  }, {
    name: 'bitterness',
    label: 'Amargor'
  }, {
    name: 'body',
    label: 'Cuerpo'
  }, {
    name: 'complexity',
    label: 'Complejidad'
  }];
  return <div className="space-y-3" data-id="element-405">
      {attributes.map(attr => <div key={attr.name} className="flex items-center" data-id="element-406">
          <span className="w-24 text-sm text-amber-700" data-id="element-407">{attr.label}</span>
          <div className="flex-1" data-id="element-408">
            <div className="flex justify-between text-xs text-amber-600 mb-1" data-id="element-409">
              <span data-id="element-410">Bajo</span>
              <span data-id="element-411">Alto</span>
            </div>
            <div className="flex space-x-1" data-id="element-412">
              {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map(value => <button key={value} type="button" disabled={readOnly} onClick={() => handleChange(attr.name, value)} className={`h-6 flex-1 rounded-sm ${profile[attr.name as keyof typeof profile] >= value ? 'bg-amber-600' : 'bg-amber-200'} ${readOnly ? 'cursor-default' : 'cursor-pointer hover:bg-amber-500'}`} aria-label={`${attr.label} nivel ${value}`} data-id="element-413"></button>)}
            </div>
          </div>
        </div>)}
    </div>;
};